import { useTranslation } from 'react-i18next';
import { Star, TrendingUp, Users } from 'lucide-react';

export const SocialProof = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: Users,
      value: '2,500+',
      label: t('socialProof.treesRated', 'Trees Rated'),
    },
    {
      icon: Star,
      value: '4.8/5',
      label: t('socialProof.avgRating', 'Average Rating'),
    },
    {
      icon: TrendingUp,
      value: '95%',
      label: t('socialProof.satisfaction', 'User Satisfaction'),
    },
  ];

  return (
    <section className="w-full max-w-4xl mx-auto py-12 px-4">
      <div className="text-center mb-8">
        <p className="text-sm text-muted-foreground uppercase tracking-wide mb-2">
          {t('socialProof.trusted', 'Trusted by Christmas enthusiasts')}
        </p>
        <h2 className="text-2xl font-bold text-foreground">
          {t('socialProof.title', 'Join thousands rating their trees')}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-6 bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4">
              <stat.icon className="w-6 h-6 text-primary" />
            </div>
            <div className="text-3xl font-bold text-foreground mb-1">{stat.value}</div>
            <div className="text-sm text-muted-foreground text-center">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
